import {Radio} from 'antd';
import {RadioGroupProps} from 'antd/es/radio';
import {RadioButtonProps} from 'antd/es/radio/radioButton';
import cn from 'classnames';
import React, {FC} from 'react';

import {TJSXContent} from 'shared/types';

import './custom-radio.less';

interface ICustomRadioItem extends RadioButtonProps {
    label: TJSXContent;
}

interface ICustomRadioProps extends RadioGroupProps {
    items?: ICustomRadioItem[];
}

export const CustomRadio: FC<ICustomRadioProps> = (
    props: ICustomRadioProps,
) => {
    const {items = [], ...restProps} = props;

    return (
        <Radio.Group
            className={cn('custom-radio')}
            {...restProps}
        >
            {items.map((item, index) => {
                const {label, value, ...restItemProps} = item;
                return (
                    <Radio.Button
                        key={index} // eslint-disable-line
                        value={value}
                        {...restItemProps}
                    >
                        {label}
                    </Radio.Button>
                );
            })}
        </Radio.Group>
    );
};
